var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgVioletTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5C14.8731 1.5 18.5 5.12693 18.5 10C18.5 14.9003 14.9003 18.5 10 18.5C5.0997 18.5 1.5 14.9003 1.5 10C1.5 5.12693 5.12693 1.5 10 1.5Z",
    fill: "#7612FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 11.8943C7.70478 12.8973 8.34749 13.8676 8.34749 13.8676C8.34749 13.8676 9.27121 12.08 10.9029 10.0476C12.6604 7.85837 13.8887 6.97705 13.8887 6.97705",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVioletTick);
export default __webpack_public_path__ + "static/media/violet-tick.f4e4884e.svg";
export { ForwardRef as ReactComponent };